var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('rich-tooltip-item',{attrs:{"bottom":true,"instant":true,"item":_vm.item,"inventory":true},scopedSlots:_vm._u([{key:"default",fn:function({ on }){return [_c('div',_vm._g({staticClass:"item"},on),[_c('img',{class:{weapon: _vm.is_weapon},attrs:{"src":_vm.url}})])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }